export default "__VITE_ASSET__Br9vyLCq__"